import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Modal,
} from 'reactstrap';

import ZebraForm from './ZebraForm';

function ZebraFormModal(props) {
  const {
    shown, t, printer, onClose,
  } = props;

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(shown);
  }, [printer, shown]);

  const onSuccess = (x) => {
    setModalOpen(false);
    props.onSuccess(x);
  };

  const jsx = (
    <Modal
      size="md"
      isOpen={modalOpen}
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          id="myLargeModalLabel"
        >
          {t('Save Printer')}
        </h5>
        <button
          onClick={() => { setModalOpen(false); onClose(); }}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <ZebraForm entity={printer} onSuccess={onSuccess} />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => { setModalOpen(false); onClose(); }}
          className="btn btn-soft-dark"
          data-dismiss="modal"
        >
          {t('Cancel')}
        </button>
        <button
          type="submit"
          form="ZebraPrinterForm"
          className="btn btn-primary"
        >
          {t('Save')}
        </button>
      </div>
    </Modal>
  );

  return jsx;
}

ZebraFormModal.defaultProps = {
  shown: false,
  onSuccess: () => { },
  printer: {},
  onClose: () => {},
};

ZebraFormModal.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  printer: PropTypes.object,
  shown: PropTypes.bool,
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(ZebraFormModal));
